import { render } from "./DeleteConfirm.vue?vue&type=template&id=dcb90890&scoped=true"
import script from "./DeleteConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteConfirm.vue?vue&type=script&lang=js"

import "./DeleteConfirm.vue?vue&type=style&index=0&id=dcb90890&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb90890"]])

export default __exports__